<template>
  <div class="cancel-value-page">
    <h1>Are you sure?</h1>
    <div>
      <ListItem
        img="communication"
        title="Your next series is Communication."
        sub-title="You'll lose access to this series, plus 300+ sessions."
      />

      <ListItem
        img="workshop"
        title="You get couples workshop every week."
        sub-title="You won't be able to join our weekly couples workshop."
      />

      <ListItem
        img="partner"
        title="Your partner gets free unlimited access."
        sub-title="94% of couples that use Lasting together report stronger relationships."
      />
    </div>
    <cta-button type="button" class="button" @click="cancelSubscription()"
      >Yes, continue with cancellation</cta-button
    >
    <cta-button type="button" class="button" @click="navToSubscriptionPage()"
      >Keep my subscription</cta-button
    >
  </div>
</template>

<script>
import CtaButton from "@/components/CtaButton";
import ListItem from "@/components/ListItem";

export default {
  name: "CancelValuePage",
  components: {
    CtaButton,
    ListItem,
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    cancelSubscription() {
      let previousAmount = this.$user.getSubscriptionPricing();
      if (previousAmount === 999) {
        this.$router.push({ name: "cancelConfirm" });
      } else {
        this.$router.push({ name: "cancelOffer" });
      }
    },
    navToSubscriptionPage() {
      this.$router.push({ name: "subscription" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/variables";
@import "@/style/mixins";

.cancel-value-page {
}

.list-item-action {
  margin-bottom: 20px;
}
</style>
